enum QrCodePrefix {
  Asset = 'E',
  SiteArea = 'Z',
  AssetCounter = 'CNT',
}

export default QrCodePrefix;
